import { SVGProps } from 'react';

const DatabaseBackup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 5c0 1.657-4.03 3-9 3S3 6.657 3 5m18 0c0-1.657-4.03-3-9-3S3 3.343 3 5m18 0v4.3M3 5v14c0 .649.63 1.28 1.796 1.8 1.166.518 2.806.898 4.674 1.08M3 12c-.001.56.466 1.107 1.35 1.583.883.475 2.147.858 3.65 1.107M16 16h-4v-4m0 4 2.09-2.09c.87-.87 2.08-1.41 3.41-1.41A4.5 4.5 0 0 1 22 17a5 5 0 0 1-9 3"
    />
  </svg>
);
export default DatabaseBackup;
